import React from 'react';
import * as PropTypes from 'prop-types';
import { constants } from 'cv-react-core';
import { HorizontalForm as HorizontalFormBase } from 'cv-library-react-web';

import getStyles from './HorizontalForm.styles';

const HorizontalForm = (props) => {
    const {
        formElements,
        onResizeStop,
        ...rest
    } = props;
    const styles = getStyles();
    const { ui } = constants;

    const handleResizeStop = (e, dir, ref) => {
        const viewId = ref.getAttribute('viewid');
        const {
            style: {
                width,
                height,
            },
        } = ref;
        onResizeStop(viewId, width, height);
    };

    return (
        <HorizontalFormBase
            contextStyles={ styles }
            formElements={ formElements }
            onResizeStop={ handleResizeStop }
            scrollIdentifier={ ui.SCROLL_CONTAINER }
            { ...rest } />
    );
};

HorizontalForm.propTypes = {
    formElements: PropTypes.arrayOf(PropTypes.element),
    onResizeStop: PropTypes.func,
};

HorizontalForm.defaultProps = {
    formElements: [],
};

export default HorizontalForm;
